import { Fragment, useEffect } from 'react'
import ReactDOM from 'react-dom'

import classes from './Modal.module.css'

const Backdrop = (props) => {
    return (
        <div
            className={classes.backdrop}
            onClick={props.onClose}
        />
    )
}

const ModalOverlay = (props) => {
    document.body.classList.add('h-screen', 'overflow-hidden');

    useEffect(()=>{
        return () => {
            document.body.classList.remove('h-screen', 'overflow-hidden');
        }
    },[])
    return (
        <div className={classes.modal}>
            <div className="flex items-center justify-center h-full landscape:h-auto landscape:m-5 lg:landscape:m-0 md:h-full md:landscape:h-full">{props.children}</div>
        </div>
    )
}

const portalElement = document.getElementById('overlays')

const Modal = (props) => {
    return (
        <Fragment>
            {ReactDOM.createPortal(
                <Backdrop onClose={props.onClose} />,
                portalElement,
            )}
            {ReactDOM.createPortal(
                <ModalOverlay>{props.children}</ModalOverlay>,
                portalElement,
            )}
        </Fragment>
    )
}

export default Modal